
CheckoutV2.Submit = function(checkout, config) {
	var _cos = this;

	var config = $.extend({
		// defaults
		'onFails' : []
	}, (config || {}));

	var request = false,
		logoutWarning = false;

	var init = function() {
		publish();
	};

	var publish = function() {
		_cos.submit = submit;
	};

	var submit = function(data) {
		if ( request || !data )
			return false;

		request = checkout.remote.call({
			'type' : 'POST',
			'data' : data
		})
			.done(done)
			.fail(fail)
			.always(always);

		return true;
	};

	var done = function(response) {
        if (response.data.successURL) {
            $(window).unbind('beforeunload');
            window.location = fixNavState(response.data.successURL);
            return;
        }

        if (response.data.errors) {
            var paymentErrorMessages = [];
            var errorMessages = [];
            var totalWarnings = [];
            var redirect = false;
			var showSalesErrorMessage = true;
            response.data.errors.forEach(function(error) {
				// We used to handle afffirmRedirect like an error that wasn't an error.
				// There have been changes to this error handling so we will check for our
				// redirect before the no-error bailout below.
				if (error.code == 'affirmRedirect') {
					var checkoutData = error.data;
					affirm.checkout(checkoutData);
					affirm.checkout.post();
					return;
				}
				
                //handles an odd one off error with billing validation issues NC-820
                if(error.data && error.data.billing){
                    errorMessages.push("The billing address associated with the selected payment method is invalid. Please update your billing address.");
                }

                switch (error.code) {
                    case 'cancelPayPal':
                        $.each(checkout.payment.getMethodsByType('paypal'), function(i, method) {
                            method.cancel();
                        });
                        errorMessages.push(error.msg);
                        break;
                    case 'paypalRedirect':
                        redirect = true;
                        window.location = error.URL;
                        return;
                        break;
                    case 'login':
                        if(confirm('You have been logged out. Page must be refreshed')){
                            location.reload(true);
                        }
                        break;
                    case 'payment':
                        // The paypal errors only come back after a failure to redirect to paypal.
                        // Only show the payment errors
                        if(error.method && error.method === 'paypal'){
                            if(error.trigger === 'shipping'){
                                var message = 'Your Zip Code is invalid for your selected Country. '
                                    + '<a href="#" class="js-thirdparty-error-shipping">Change Shipping Address</a>';
                                paymentErrorMessages.push(message);
                            } else {
                                paymentErrorMessages.push(error.msg);
                            }
                        } else { // just in case the server does something strange, show errors in payment and review
                            paymentErrorMessages.push(error.msg);
                            errorMessages.push(error.msg);
                        }
                        break;
                    case 'paymentMethodAmounts':
                        paymentErrorMessages.push(error.msg);
                        errorMessages.push(error.msg);
                        break;
                    case 'paymentMethod':
                        paymentErrorMessages.push(error.error);
                        errorMessages.push(error.error);
                        break;
                    case 'paymentMethodAmount':
                        paymentErrorMessages.push(error.msg);
                        errorMessages.push(error.msg);
                        break;
                    case 'paymentMethodFields':
                        Object.keys(error.error).forEach(function(key){
                            var content = key + ' - ' + error.error[key];
                            paymentErrorMessages.push(content);
                            errorMessages.push(content);
                        });
                        break;
                    case 'billship':
                        if(error.data.billing){
                            paymentErrorMessages.push('Billing information is invalid.');
                        }
                        break;
                    case 'cartContents':
                      showSalesErrorMessage = false;

                      // disable progress nav so view cart is only option
                      $('.js-progress-shipping, .js-progress-payment')
                        .removeClass( "active" )
                        .unbind( "click" );

                      $('.js-progress-cart').unbind( "click" );

                      // bind a cart reload to cart buttons
                      $('.order-summary .js-view-cart, .js-progress-cart').on('click', function() {
                        if(error.data && error.data.data) {
                          checkout.cart.updateItems(error.data);
                        } else {
                          errorMessages.push(error.msg);
                        }

                        // Remove validation info message and show order totals. Restore next step button. Remove click bindings.
                        $('.js-progress-cart').unbind( "click" );
                        $('.order-summary .js-next-step').show();
                        $('.order-summary .js-view-cart')
                          .hide()
                          .unbind( "click" );
                        $('.submit-validation-info').hide();
                        $('.submit-validation-info .msg-text').html('');
                        $('#order-totals').show();
                      });

                      // Hide order totals and show validation info message. Swap next step button for view cart button.
                      $('#order-totals').hide();
                      $('.submit-validation-info .msg-text').html(submitValidationMessage());
                      $('.submit-validation-info').show();
                      $('.order-summary .js-next-step').hide();
                      $('.order-summary .js-view-cart').show();
                      break;
                    case 'totals':
                        totalWarnings.push( error.msg );
                        break;
                    case 'promotionChanged':
                        showSalesErrorMessage = false;
                        var msg = error.msg || 'Promotion has changed or is no longer valid';
                        totalWarnings.push( msg );
                        break;
                    case 'refreshShipQuote':
                    case 'shippingService':
                    case 'shippingAddress':
                    case 'billShipChanged':
                    default:
                        if(error.error) {
                            errorMessages.push(error.error);
                        } else {
                            errorMessages.push(error.msg);
                        }

                        if(checkout.currentStepName() === 'payment'){
                            if(error.error) {
                                paymentErrorMessages.push(error.error);
                            } else {
                                paymentErrorMessages.push(error.msg);
                            }
                        }

                }
                if(error.msg || error.error || error.data) {
                    checkout.loading();
                }
            });

            if ( totalWarnings.length > 0 ) {
                var alertMsg = (
                    'Order Totals have changed. Page must be refreshed.' + "\n\n"
                    + "Reasons:\n - "+totalWarnings.join("\n - ")
                );
                alert( alertMsg );
                location.reload( true );
                return;
            }

            if(errorMessages.length < 1 && !redirect && showSalesErrorMessage){
                errorMessages.push(checkout.cart.shipping.getSalesMessageText());
            }

            if ( hasNonceFailure( paymentErrorMessages ) ) {
                handleNonceFailure();
            }
            else {
                if(paymentErrorMessages.length > 0){
                    checkout.payment.showErrors(paymentErrorMessages.join('<br>'));
                }

                if(errorMessages.length > 0) {
                    checkout.cart.error();
                    checkout.cart.error(errorMessages.join('<br>'));
                }
            }

            checkout.cart.totals.loading(false);
            checkout.loading( false );
        }
    };
	
	var submitValidationMessage = function() {
		var msg = "The price and/or availability of products in this order have changed.<br/><br/>View cart to see the changes.";
		return msg;
	};
	
    var fail = function(request) {
        // if we hit this method, things went bad. Show the generic "please call customer service" message
        checkout.cart.error();
        checkout.cart.error(checkout.cart.shipping.getSalesMessageText());
        checkout.cart.totals.loading(false);
        checkout.loading( false );
    };

	var always = function() {
		request = false;
	};

    var hasNonceFailure = function( paymentErrorMessages ) {
        var nonceMessagePattern = /payment_method_nonce/;
        var nonceMessages = paymentErrorMessages.filter(
            function( errorMessage ) {
                return errorMessage && errorMessage.match( nonceMessagePattern );
            }
        );

        return ( nonceMessages && nonceMessages.length > 0 );
    };

    var handleNonceFailure = function() {
        var currentPaymentMethod = checkout.payment.currentPaymentMethod;
        $.each( checkout.payment.activeMethods, function( i, paymentMethod ) {
            if ( paymentMethod.method == "creditcard" || paymentMethod.method == 'btpaypal' ) {
                currentPaymentMethod.mode.removeStoredCard( paymentMethod.id );
            }
        } );

        checkout.payment.setActivePaymentMethods( [] );
        checkout.payment.setMethodByName( "creditcard" );
        checkout.payment.showErrors( "Payment failed, please enter a valid payment method" );
        checkout.scrollToInvalidStep( "payment" );
    };

	init();
};
